import type { Plugin } from '@nuxt/types';
import DOMPurify from 'isomorphic-dompurify';
import { unescape } from 'lodash-es';

declare module 'vue/types/vue' {
  interface Vue {
    $dompurify(html: string): string;
  }
}

const plugin: Plugin = (_, inject) => {
  inject('dompurify', (html: string): string => unescape(DOMPurify.sanitize(html)));
};

export default plugin;
